import Page from '@shell/Page'
import CheckboxGroup from '@ui/forms/CheckboxGroup/CheckboxGroup'
import { CheckboxGroupOption } from '@ui/forms/CheckboxGroup/CheckboxGroupItem'
import { useState } from 'react'
import { View } from 'react-native'

const data = [
  {
    id: 1,
    title: 'Order 1',
    desc: 'WH-DE-2332-23',
    image:
      'https://frameimage.brillen.de/GINO-3663873026620/OVERVIEW/picture.jpg',
  },
  {
    id: 2,
    desc: 'WH-DE-2332-24',
    title: 'Order 2',
    disabled: true,
    image:
      'https://dmh0k4081ik4z.cloudfront.net/images/frame/thumbnail/300x0W/FZ175-C2.jpg',
  },
  {
    id: 3,
    desc: 'WH-DE-2332-25',
    title: 'Order 3',
    image:
      'https://dmh0k4081ik4z.cloudfront.net/images/frame/thumbnail/300x0W/FZ175-C2.jpg',
  },
] satisfies (CheckboxGroupOption & { image?: string })[]

export default function OrderCheckboxes() {
  const [active, setActive] = useState<string[]>([])
  const [activeRadio, setActiveRadio] = useState<string[]>([])

  return (
    <Page stage="dev">
      <View className="gap-16 p-32">
        <CheckboxGroup active={active} setActive={setActive}>
          {data.map((item) => (
            <CheckboxGroup.ItemImage key={item.id} {...item} />
          ))}
        </CheckboxGroup>
        <CheckboxGroup
          mode="radio"
          active={activeRadio}
          setActive={setActiveRadio}
        >
          {data.map((item) => (
            <CheckboxGroup.Item key={item.id} {...item} />
          ))}
        </CheckboxGroup>
      </View>
    </Page>
  )
}
